import { useMutation } from 'react-query';
import marketingPublicationInteractionService from './marketingPublicationInteraction.services';

export function useMarketingPublicationInteraction() {
  return useMutation(
    marketingPublicationInteractionService.postMarketingPublicationInteraction,
  );
}
